// extracted by mini-css-extract-plugin
module.exports = {"pcItem":"pcItem___3QM67","title":"title___77tzO","img":"img____LmR8","mobileItem":"mobileItem___3Phhy"};